import { Component, OnInit, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { StratigraphicWellBondingRequirement } from "../../../../common/models/well.model";
import { CommonDatePickerComponent } from "../../../../common/components/common-date-picker/common-date-picker.component";


@Component({
    selector: 'stratigraphic-bonding-editor',
    templateUrl: './stratigraphic-bonding-editor.component.html',
    styleUrls: ['./stratigraphic-bonding-editor.component.scss', '../../../../core/components/dynamic-dialog/dynamic-dialog.component.scss'],
    standalone: false
})
export class StratigraphicBondingEditorComponent implements OnInit {

    private _api: string;
    private _currentRequirement: StratigraphicWellBondingRequirement;
    private _show: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    @Output() bondingRequirementsUpdated: EventEmitter<StratigraphicWellBondingRequirement> = new EventEmitter<StratigraphicWellBondingRequirement>();

    get currentRequirement(): StratigraphicWellBondingRequirement {
        return this._currentRequirement;
    }

    @Input() set currentRequirement(value: StratigraphicWellBondingRequirement) {
        this._currentRequirement = value;
        this.presetForm(this._currentRequirement);
    }

    @ViewChild(CommonDatePickerComponent, { static: true }) datePicker: CommonDatePickerComponent;

    form: FormGroup;

    get message(): string {
        return `<span class=\"bold\">Update Bonding Requirements for ${this._api}</span>`;
    }

    get showDialog(): boolean {
        return this._show.value;
    }

    constructor(private builder: FormBuilder) {
        this.form = this.builder.group({
            bondingAmount: [null, []],
            requiredDate: [null, []]
        });
    }

    ngOnInit() {
          
    }


    cancel(): void {
        this._show.next(false);
    }

    openDialog(api: string): void {
        this._api = api;
        this._show.next(true);
    }

    presetForm(existing: StratigraphicWellBondingRequirement): void {
        if (this.form == null) {
            this.form = this.builder.group({
                bondingAmount: [null, []],
                requiredDate: [null, []]
            });
        }
        if (existing != null) {
            if (existing.amountRequired != null) {
                this.form.get('bondingAmount').setValue(parseFloat(existing.amountRequired.toString()));
            } else {
                this.form.get('bondingAmount').setValue(null);
            }
            if (existing.requiredBy != null) {
                this.form.get('requiredDate').setValue(new Date(existing.requiredBy));
                this.datePicker.setCtrl(new Date(existing.requiredBy));
            } else {
                this.form.get('requiredDate').setValue(null);
            }
        } else {
            this.form.get('bondingAmount').setValue(null);
            this.form.get('requiredDate').setValue(null);
        }
       
    }

    requiredDateUpdated(dt: Date): void {
        this.form.get('requiredDate').setValue(dt);
    }

    submit(): void {
        let req: StratigraphicWellBondingRequirement = {
            id: 0,
            apiNumber: this._api,
            amountRequired: this.form.get('bondingAmount').value,
            requiredBy: this.form.get('requiredDate').value,
            effectiveFrom: new Date(),
            isPending: true,
            isDeleted: false
        } as StratigraphicWellBondingRequirement;
        this.form.get('bondingAmount').setValue(null);
        if (this.datePicker != null) this.datePicker.setCtrl(null);
        this.bondingRequirementsUpdated.emit(req);
        this._show.next(false);
    }
}
